export const gtAmerica = `'GT America', 'Helvetica Neue', sans-serif`;
export const sabon = `'Sabon', 'Garamond', serif`;
